"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUCEventData = void 0;
function buildUCEventData(message, innerType, durationInMS, customData) {
    let eventData = {};
    eventData["UCEvent" /* CONSTS.UC_EVENT_NAME */] = Object.assign(Object.assign({}, customData), { message, innerType });
    durationInMS && (eventData["UCEvent" /* CONSTS.UC_EVENT_NAME */].durationInMS = durationInMS);
    return eventData;
}
exports.buildUCEventData = buildUCEventData;
//# sourceMappingURL=build-uc-event-data.js.map